import React from "react";

import Drawer from "../components/Configurator/ui/Drawer";
import { cn } from "../lib/utils";
import Main from "../components/Configurator/scene/Main";

const Home = ({ type, currentPage }) => {
    const isTrade = type === 'trade';

    return (
        <div className={cn(
            "flex flex-col xl:flex-row overflow-hidden",
            isTrade ? "h-viewport" : "h-viewport lg:h-[calc(100dvh-120px)]"
        )}>
            <Main />
            <Drawer type={type} />
        </div>
    );
};

export default Home;
